import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  bulkInventoryBinService,
  type ProcessBulkInventoryBinsRequest,
  type ProcessBulkInventoryBinsResponse,
} from '@/services/propertyBook/BulkInventoryBinService';
import { queryKeys } from '@/lib/queryKeys';

export const useProcessBulkInventoryBins = () => {
  const queryClient = useQueryClient();

  return useMutation<ProcessBulkInventoryBinsResponse, unknown, ProcessBulkInventoryBinsRequest>({
    mutationFn: (payload) => bulkInventoryBinService.processBins(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.bulkInventoryBin.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.entities.lists() });
      void queryClient.invalidateQueries({ queryKey: ['exchange-replacement-options'] });
    },
  });
};
